import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const MapGuideButton: React.FC = () => {
  const navigate = useNavigate();
  const [isActive, setIsActive] = useState(false);

  const handleMainClick = () => {
    isActive ? navigate('/map-guide') : setIsActive(true);
  };

  const handleResetClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsActive(false);
  };

  const mainIcon = isActive
    ? '/assets/images/guide-landing/map/map_icon.png'
    : '/assets/images/guide-landing/map/map_icon2.png';

  return (
    <StyledButton $isActive={isActive} onClick={handleMainClick}>
      <img src={mainIcon} alt="map icon" />
      {isActive && (
        <>
          <span>지도검색 이용가이드</span>
          <img
            src="/assets/images/guide-landing/map/map_icon3.png"
            alt="close icon"
            onClick={handleResetClick}
            style={{ cursor: 'pointer' }}
          />
        </>
      )}
    </StyledButton>
  );
};

export default MapGuideButton;

const StyledButton = styled.button<{ $isActive: boolean }>`
  width: ${(props) => (props.$isActive ? '206px' : '40px')};
  height: 40px;
  position: absolute;
  top: calc(100% + 12px);
  left: 12px;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.$isActive ? 'space-between' : 'center')};
  gap: ${(props) => (props.$isActive ? '8px' : '0')};
  padding: ${(props) => (props.$isActive ? '8px' : '8px 14px 8px 16px')};
  border-radius: ${(props) => (props.$isActive ? '20px' : '100px')};
  border: ${(props) =>
    props.$isActive ? '1px solid #33353833' : '1px solid #e1e2e4'};
  background-color: ${(props) =>
    props.$isActive ? 'rgba(51, 53, 56, 0.8)' : '#fff'};
  box-shadow: ${(props) =>
    props.$isActive ? '0px 0px 8px 0px #33353833' : 'none'};
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    border: 1px solid #e1e2e4;
    background-color: ${(props) =>
      props.$isActive ? 'rgba(51, 53, 56, 0.9)' : '#f0f0f0'};
  }

  &:active {
    border: 1px solid #e1e2e4;
    background-color: ${(props) =>
      props.$isActive ? 'rgba(51, 53, 56, 1)' : '#d9d9d9'};
    transform: scale(0.98);
  }

  img {
    object-fit: contain;
    display: block;
  }
`;
